import React, {Component} from 'react';
import '../App.css';
import Spinner from 'react-bootstrap/Spinner'

class SmsLogin extends Component {

    constructor() {
        super();
    
        this.refCode = React.createRef();
      }

    state = {    
        errorMsg : '',
        onceTimeCode:''
    }
    
    setUserOnceTimeSmsCode = (val) =>  {        
        this.setState({onceTimeCode:val});  
    }  


    keyPressCode = (event) =>  {        
        if (event.key == 'Enter')  {
            this.sendCodeSms();
        }
    } 

    sendCodeSms = () => {

        if(this.props.loading)
            return;

        console.log('SmsLogin sendCodeSms clicked');

        let data = {};
        data.onceTimeCode = this.state.onceTimeCode;
        this.props.sendCodeSms(data);  
    }    
    

    render() {     
    
        return (                  
            <React.Fragment>
                <div className="hp_loginField_container">                                    
                    <div className="cntered-flex" >    
                        <div>

                            {(this.props.codeOverSms) ? 
                            <div className="login_note">
                                קוד נשלח לטל. נייד הרשום במערכת
                                <div className="directionLtr">{this.props.CellNumberMask}</div>
                            </div>
                            :
                            <div className="login_note">
                                קוד נשלח למייל הרשום במערכת
                                <div className="directionLtr">{this.props.CellNumberMask}</div>
                            </div>
                            }


                            <div className="hp_search_field_container hp_search_field_marginRight15">                
                                <span className="hp_search_field_dropDown_inner_placeBox_title_small">
                                קוד</span>              
                                <div className="hp_search_field_titleLogin loginUser">
                                    <input type="text" 
                                        className="loginUser"  
                                        placeholder="קוד"
                                        maxLength="6"
                                        onChange={e => this.setUserOnceTimeSmsCode(e.target.value)} 
                                        onKeyPress={this.keyPressCode} 
                                        ref={this.refCode} />
                                </div>
                            </div>
                            {(this.state.attemptFailed > 0) ?
                            <div>
                                login failed!
                            </div>                                           
                            : null}                                                 

                        </div>
                    </div>
                </div>


                <div className="cntered-flex hp_login_box_msgPanel"> 
                    <div >{this.props.errorMsg}</div>
                </div> 


                {(this.props.loading) ?
                    <React.Fragment>
                        <div className="cntered-flex directionRtl marginBottom10">
                        מבצע כניסה למערכת ...
                        <Spinner
                            as="span"
                            animation="border"

                            role="status"
                            aria-hidden="true"                                        
                        />      
                        </div>
                        </React.Fragment>
                    : null}


                <div className="cntered-flex ">
                    <div className="hp_search_main_button marginTop20" onClick={() => this.sendCodeSms()}>
                        <span className="hp_search_main_button_title">
                        כניסה
                        </span>
                    </div>
                </div>

            </React.Fragment>

                            

        )
    }
}


export default SmsLogin;


